import { useQuery } from "@tanstack/react-query";
import { getSaveOptions } from "../services/motionServices";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";

export function useItemsMotion(){
    return useQuery({
        queryKey: ['itemsToMotion'],
        queryFn: () => getSaveOptions(),
        staleTime: FIVE_MINUTES_IN_MS,
    })
}